import styled from 'styled-components'

export const LatestStoryDiv = styled.div`
display:flex; 
justify-content:center;
/* text-align:start; */
/* background-color:red; */

.roww{
    background-color: red;
    width: 100%;
 
    h3{
        font-family: Gilroy;
        font-style: normal;
        font-weight: bold;
        font-size: 40px;
        font-feature-settings: 'liga' off;
        color: #02021C;
        padding-bottom:-1000px;
    }

    p{
        font-family: Gilroy;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        font-feature-settings: 'liga' off;
        color: #24292E;
        margin: 10px 0px;
    }

}

`